<template>
  <v-container fluid>
    <tab-nav/>
    <v-layout>
      <v-flex>
        <v-card
          flat
          v-if="getTabActive === this.LIST"
        >
          <models-list/>
        </v-card>
        <v-card
          flat
          v-if="getTabActive === this.NEW"
        >
          <model-edit/>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ModelEdit from '@/components/Models/ModelEdit'
import ModelsList from '@/components/Models/ModelsList'

export default {
  components: {
    'model-edit': ModelEdit,
    'models-list': ModelsList
  },

  data () {
    return {
      LIST: 0,
      NEW: 1,
      breadcrumbs: [
        { text: 'Dashboard', disabled: false, href: '/dashboard' },
        { text: 'Model s', disabled: true }
      ],
      navMenu: [
        { title: 'List' },
        { title: 'New' }
      ]
    }
  },
  mounted: function () {
    this.loadBreadcrumbs(this.breadcrumbs)
    this.loadCurNav(this.navMenu)
  },
  watch: {
    getTabActive: function (newData) {
      if (newData === this.NEW) {
        this.clearModelId()
        // now as class
        this.startEditModel(this.model)
      }
    }
  },
  computed: {
    ...mapGetters({
      getTabActive: 'nav/getTabActive',
      model: 'models/model'
    })
  },
  methods: {
    ...mapActions({
      loadBreadcrumbs: 'nav/loadBreadcrumbs',
      loadCurNav: 'nav/loadCurNav',
      clearModelId: 'models/clearModelId',
      startEditModel: 'models/startEditModel'
    })
  }
}
</script>
